import { render, staticRenderFns } from "./EventGuideModal.vue?vue&type=template&id=13297eea&"
import script from "./EventGuideModal.vue?vue&type=script&lang=js&"
export * from "./EventGuideModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/staging.portal.letsreimagine.org/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13297eea')) {
      api.createRecord('13297eea', component.options)
    } else {
      api.reload('13297eea', component.options)
    }
    module.hot.accept("./EventGuideModal.vue?vue&type=template&id=13297eea&", function () {
      api.rerender('13297eea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/home/components/event/modals/EventGuideModal.vue"
export default component.exports